<template lang="pug">
.fileSpace
  //- el-button.freshBtn(v-if="noDelete && flowFileList.length" type="text" @click="refresh") 刷新轻量化状态
  el-table.fileView(v-if="flowFileList.length > 0" :data="flowFileList" :show-header="false" max-height="200px")
    el-table-column(label="名称" v-slot="{row}")
      .labelList
        fileLightFlag.lightShare(:row="row" :form-flow="true" :readonly="true")
        img(:src="className(row)")
        .title(@click="preview(row)" :title="row.fileName") {{row.fileName}}
        span.path(v-if="row.pathName && (showBar||isRVT)") {{row.pathName}}
    el-table-column(label="绑定" v-if="flowKey==='check'" width="86px" v-slot="{row}")
      .table_class.approval_class(v-if="row.bindStatus===0") 未绑定
      .table_class.adopt_class(v-else-if="row.bindStatus===1") 绑定成功
      .table_class.reject_class(v-else) 绑定失败
    el-table-column(label="操作"  fixed="right" width="60px" v-slot="{row}")
      .midd-table
        //- i.el-icon-download(title="下载" @click="downLoadFile(row)" )
        i.el-icon-delete(title="删除" v-if="!noDelete" @click="deleteRow(row)")
  </template>

<script>
import { mapState } from "vuex";
import { Notify, Dialog } from "vant";
import { tableRowIcon, common2D3DFileType } from "@/CommonDP/utils/docPublic";
import { viewAppFileMethods } from "@/CommonDP/pages/appView/utils";
import { getApprove } from "@/CommonDP/components/processComponents/flowNewConfig/mapStore.js";
import XtDesignService from "@/CommonDP/service/XtDesign-service";
import fileLightFlag from "@/CommonDP/components/fileLightFlag";

export default {
  components: { fileLightFlag },
  props: {
    noDelete: { type: Boolean, default: false },
    flowKey: { type: String, default: "" },
    uuid: { type: String, default: "" }
  },
  data() {
    return {
      urlflowFileList: [],
      proofread_png: require("@/CommonDP/assets/approval/proofread.png")
    };
  },
  computed: {
    ...mapState({
      prjInfo: (state) => state.projectMg.prjObj,
      floderObj: (state) => state.uploaderLocal.floderObj,
      enterpriseId: (state) => state.enterprise.enterpriseId,
      routerParams: (state) => state.projectMg.routerParams,
      userInfo: (state) => state.user.userInfo
    }),
    flowFileList() {
      return this.urlflowFileList.length > 0 ? this.urlflowFileList : getApprove(this.uuid)?.getFileInfoList();
    },
    nodeList() {
      return getApprove(this.uuid)?.getFlowNodeDtoList();
    },
    // cad跳转样式
    showBar() {
      return window.location.href.indexOf("jsName=BimEx") === -1;
    },
    // rvt跳转样式
    isRVT() {
      return window.location.href.indexOf("jsName=BimExRVT") === -1;
    },
    flowInstanceId() {
      return getApprove(this.uuid)?.getMessage()?.flowInstanceId || "";
    }
  },
  watch: {
    floderObj(newValue) {
      if (newValue.fileId) {
        // 本地上传改成1 uploader组件上传有问题
        if (newValue.uploadType === "4") {
          newValue.uploadType = 1;
        }
        getApprove(this.uuid)?.addStartAttachedFiles([newValue]);
      }
    }
  },
  methods: {
    // 刷新轻量化状态
    refresh() {
      const noSuccessfileList = this.flowFileList.filter((item) => common2D3DFileType(item));
      noSuccessfileList.forEach(async (ele) => {
        const { data } = await XtDesignService.getFileDetails(ele.fileId);
        this.$set(ele, "status", data.status);
      });
    },
    // 接口：获取文件列表
    getFileList() {
      return this.flowFileList || [];
    },
    setFileList(fileList) {
      this.urlflowFileList = fileList || [];
      getApprove(this.uuid)?.addStartAttachedFiles(this.urlflowFileList);
    },
    className(row) {
      return tableRowIcon(row);
    },

    // 预览
    preview(row) {
      const data = {
        fileType: row.fileType,
        fileId: row.fileId,
        versionId: row.versionIds || row.fileVersion,
        flowInstanceId: this.flowInstanceId
      };
      viewAppFileMethods(row, data);
    },
    // 下载
    downLoadFile(row) {
      return Notify({ type: "warning", message: "暂不支持该功能" });
    },
    // 删除
    deleteRow(row) {
      Dialog.confirm({
        message: `您确定取消${row.fileName}文件嘛`
      })
        .then(async () => {
          getApprove(this.uuid)?.deleteStartAttachedFiles(row);
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="scss" scoped>
.fileSpace {
  width: 100%;

  .freshBtn {
    float: right;
  }
}
.fileView {
  border-top: 1px solid #ebeef5;
}
.labelList {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: 25px;
  .lightShare {
    position: absolute;
    left: 18px;
  }
  img {
    width: 22px;
    height: 22px;
  }
  .title {
    margin-left: 5px;
    cursor: pointer;
    font-size: 14px;
  }
  .path {
    margin-left: 50px;
  }
  .el-link {
    margin-left: 15px;
  }
}
.table_class {
  width: 70px;
  font-size: 14px;
  border-radius: 15px;
  margin: 0 5px;
  text-align: center;
}
.approval_class {
  background: rgba(243, 124, 38, 0.15);
  color: #f37c26;
  text-align: center;
}
.adopt_class {
  background: rgba(0, 182, 50, 0.24);
  color: #00b632;
  text-align: center;
}
.reject_class {
  background: rgba(236, 54, 42, 0.15);
  color: #ec3226;
  text-align: center;
}
.midd-table {
  display: flex;
  align-items: center;
  justify-content: center;
}
.midd-img {
  margin-right: 15px;
  display: block;
  color: var(--theme-color);
  width: 16px;
  height: 16px;
  cursor: pointer;
}
.el-icon-download {
  font-size: 16px;
  color: var(--theme-color);
  cursor: pointer;
}
.el-icon-delete {
  margin-left: 5px;
  font-size: 16px;
  color: #f54f45;
  cursor: pointer;
}
</style>
